<template>
  <div>
    <Top />
    <div class="container">
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-md-6">
        <br />
        <div class="margin-top-75"></div>
          <div class="header-wrapper">
            <h1 class="text-danger left-header">Ett fel har inträffat!</h1>
          </div>
          <div class="clearfix"></div>
          <p>
            En text kunde inte laddas in från vårat innehållshanteringssystem, vi ber om ursäkt för besväret.
            Var vänlig <router-link to="/faq/contact">kontakta supporten</router-link>.
          </p>
          <div v-if="err">
            <p>Felmeddelande:</p><pre class="pre">{{ err }}</pre>
          </div>
        </div>
        <div class="col-sm"></div>
      </div>
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-md-6">
          <div class="clearfix--min"></div>
          <button class="btn btn-primary btn-lg btn-block" @click="$router.push('/')">Till startsidan</button>
        </div>
        <div class="col-sm"></div>
      </div>
    </div>
    <Bottom />
  </div>
</template>

<script>
import Top from '../../src/components/Top'
import Bottom from '../../src/components/Bottom'

export default {
  name: 'errorcontent',
  props: ['error'],
  data () {
    return {
      err: this.$props.error ? this.$props.error : ''
    }
  },
  components: {
    Top,
    Bottom
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container {
  margin-bottom: 10vh;
  min-height: 60vh;
}
.margin-top-75 {
  margin-top: 75px;
}
.header-wrapper {
  display: flex;
}
.left-header {
  text-align: left;
}
.pre {
  padding: 10px;
  border: 1px solid gray;
  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/ErrorContent.vue